import { Swiper, SwiperSlide } from 'swiper/react';
import { Scrollbar, Pagination, Navigation } from 'swiper';
import EFPicture from '@elem/compCommon/EFPicture';
import EditorVideo from 'lowcode/components/EditorVideo';
import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';

export default function ComJP({ title, desc, cls, imgArr, imgArrInfo }: any) {
    const { isMobile } = useGlobal();
    const modules = isMobile ? [Scrollbar, Pagination, Navigation] : [Scrollbar, Pagination, Navigation];

    return (
        <div className={`com-jp ${css['com-jp']}`}>
            <h2 className="dp3-title">{title}</h2>
            {desc && <p className="dp3-desc">{desc}</p>}
            <Swiper
                className={`swiper-box ${imgArr?.length === 1 ? 'single' : ''}`}
                modules={modules}
                navigation={imgArr?.length > 1}
                pagination={imgArr?.length > 1}
                loop={imgArr?.length > 1}
                spaceBetween={0}
                // centeredSlides={true}
                slidesPerView={'auto'}
                initialSlide={0}
            >
                {imgArr?.map((img: any, k: number) => {
                    const infoItem = (imgArrInfo && imgArrInfo[k]) || {};
                    return (
                        <SwiperSlide className={`swiper-item`} key={k}>
                            <div className="swiper-item-in">
                                {infoItem.upTitle && <div className="card-upTitle">{infoItem.upTitle}</div>}
                                <div className="card-img">
                                    {/* <EditorImgVideo pc={img} /> */}
                                    {img.indexOf('.mp4') > -1 ? <EditorVideo src={img} loop autoPlay /> : <EFPicture src={img} alt={title} />}
                                </div>
                                {imgArrInfo && imgArrInfo[k] && (
                                    <div className="card-info">
                                        {imgArrInfo[k]?.title && (
                                            <p className="card-title">
                                                {imgArrInfo[k]?.title}
                                                {imgArrInfo[k].lMsTipsLink && (
                                                    <a className="card-title-link" href={imgArrInfo[k].lMsTipsLink}>
                                                        {imgArrInfo[k].lMsTips}
                                                    </a>
                                                )}
                                            </p>
                                        )}
                                        {imgArrInfo[k]?.desc && (
                                            <p className="card-desc">
                                                {imgArrInfo[k]?.desc}
                                                {infoItem.rMsTips && <span className="card-rMsTips">{infoItem.rMsTips}</span>}
                                                {infoItem.rMsTips2 && <span className="card-rMsTips card-rMsTips-2">{infoItem.rMsTips2}</span>}
                                            </p>
                                        )}
                                    </div>
                                )}
                            </div>
                        </SwiperSlide>
                    );
                })}
            </Swiper>
        </div>
    );
}
